const salesman = [
  // 业务员注册
  {
    path: '/salesman/receive',
    component: resolve => require(['@/view/salesman/Receive'], resolve),
    meta: {
      title: '注册'
    }
  }
]
export default salesman;



// WEBPACK FOOTER //
// ./src/router/salesman.js